import { computeAvailability, showOffersForToday } from "@/utils";
import ApiService from "./ApiService";
import moment from "moment";
import {
  BlockSlotBodyType,
  BlockSlotResponseType,
  CheckSlotAvailabilityResponseType,
  FetchBookingConfigResponseType,
  FetchOfferResponseType,
  GetAvailabilityResponseType,
  GetSlotsResponseType,
  GetVenueDetailsResponseType,
  ReverseBookingResponseType,
  SlotAvailabilityType,
} from "../types/venue.types";

class VenueApi extends ApiService {
  constructor() {
    super(
      `${process.env.BACKEND_HOST_URL}/api` || "https://api.turftown.in/api"
    );
  }

  async getVenueDetails(id: string, useCache?: boolean) {
    return this.post<GetVenueDetailsResponseType>(
      `/v2/venue/public/get_venue_details/${id}`,
      {},
      false,
      useCache
    );
  }

  private async fetchOffer(venueId: string, userId: string) {
    const body = {
      venue: [venueId],
    };
    return this.post<FetchOfferResponseType>(
      "v2/venue/public/fetch_venue_offer",
      body
    );
  }

  private async getAvailability(
    venueId: string,
    venueDate: moment.Moment,
    venueType: string
  ) {
    const body = {
      booking_date: venueDate.toDate(),
      venue_type: venueType,
    };
    return this.post<GetAvailabilityResponseType>(
      `user/public/slots_available/${venueId}`,
      body,
      true
    );
  }

  private async getSlots(
    venueId: string,
    venueDate: moment.Moment,
    venueType: string
  ) {
    const body = {
      day: venueDate.format("dddd").toLowerCase(),
      venue_type: venueType,
    };
    return this.post<GetSlotsResponseType>(
      `user/public/slots_list1/${venueId}`,
      body
    );
  }

  async fetchSlotsAndOffer(body: {
    venueId: string;
    userId: string;
    date: moment.Moment;
    date1: moment.Moment;
    base_type: string;
    courts: number;
  }) {
    try {
      const [offers, slots_available, slots_list] = await Promise.all([
        this.fetchOffer(body.venueId, body.userId),
        this.getAvailability(body.venueId, body.date1, body.base_type),
        this.getSlots(body.venueId, body.date1, body.base_type),
      ]);
      const computedSlots = await computeAvailability(
        { ...slots_list },
        // @ts-ignore
        { ...slots_available.data },
        body.base_type,
        body.date1,
        body.courts
      );
      // console.log("computedSlots", {
      //   slots_list,
      //   slots_available,
      //   base_type: body.base_type,
      //   date1: body.date1,
      //   courts: body.courts,
      //   computedSlots,
      // });
      const offerComputation =
        offers.data.length > 0
          ? showOffersForToday(body.date, offers.data)
          : [];

      return {
        slotsAvailable: slots_available,
        slotsList: slots_list,
        offerFetched: offerComputation,
        offerExists: offerComputation.length > 0,
        slotPicker: [...computedSlots],
      };
    } catch (error) {
      console.error("❌ fetchSlotsAndOffer error", error);
      throw error;
    }
  }

  async checkSlotAvailability(venueId: string, body: SlotAvailabilityType) {
    try {
      const response = this.post<CheckSlotAvailabilityResponseType>(
        `v2/bookings/check_slot_available_via_slots/${venueId}`,
        body,
        true
      );
      return response;
    } catch (e) {
      console.error("❌ checkSlotAvailability error", e);
      return null;
    }
  }

  async blockSlot(venueId: string, body: BlockSlotBodyType[]) {
    try {
      const response = await this.post<BlockSlotResponseType>(
        `v2/bookings/block_slot_new/${venueId}`,
        body,
        true
      );
      return response.data;
    } catch (e) {
      console.error("❌ blockSlot error", e);
      return null;
    }
  }

  async reverseVenueBooking(bookingId: string) {
    try {
      const response = await this.post<ReverseBookingResponseType>(
        `user/booking_timeout/${bookingId}`,
        {},
        true
      );
      return response;
    } catch (e) {
      console.error("❌ reverseBooking error", e);
      return null;
    }
  }
  async cancelGameAPI(gameId: string) {
    try {
      const response = await this.post(
        `/v2/game/cancel_game/${gameId}`,
        {},
        true
      );
      return response;
    } catch (e) {
      console.error("❌ reverseBooking error", e);
      return null;
    }
  }
  async fetchBookingConfig(body: { booking_id: string }) {
    try {
      const response = await this.post<FetchBookingConfigResponseType>(
        "v2/user/app_booking_config",
        body,
        true
      );
      return response;
    } catch (err) {
      console.error("❌ fetchBookingConfig error", err);
      return null;
    }
  }
  async bookSlotAndHost(body) {
    try {
      return await this.post("v2/bookings/book_slot_and_host", body, true);
    } catch (error) {
      console.error("booking error", error);
    }
  }
}

export const venueApi = new VenueApi();
